export * from './lib';

export const CONNECTOR_TYPE = {
  '4e19606c-82b8-4f72-808f-2f89eccb292d': 'Forwarder',
  '78cd1533-3e4f-4dff-8448-4a5f9ec1e885': 'SingleCollector',
  '8afc266f-d2d7-46c8-80de-cde94ef1dafc': 'AggregateCollector',
  'd7814ce3-edf2-44c2-b551-581ac842cfef': 'Validator'
};

export const DIFFERENTIAL_REPORT_TYPE = '38f24061-a70f-415a-b378-bc9575b7ac6a';
export const DIFFERENTIAL_NETWORK_DISCOVERY_REPORT_TYPE = '9adff777-0259-48fd-aa11-6594a7b4dc7d';
export const REPORT_INSTANCE_DIFFERENTIAL_REPORT_TYPE = '57cf1e6f-1288-4911-a524-538d7cd48185';


export const FULL_HEIGHT = 'calc(100vh - 149px)';

export const MAX_PAGE_SIZE = 100000;

export const ATTACKIQ_ID = '906d5ec6-101c-4ae6-8906-b93ce0529060';

export const PREVENTION_OUTCOME_IDS = {
  PASSED: 1,
  FAILED: 2,
  ERRORED: 3,
  DETECTED: 4,
  NOT_DETECTED: 5,
  TRUE_POSITIVE: 6,
  FALSE_POSITIVE: 7,
  PENDING: 8,
  NOT_APPLICABLE: 9
};

export const TAGGING_CONTENT_TYPE = {
  ASSESSMENT: 'assessment',
  ASSET: 'asset',
  USER: 'user'
};

export const STATUS_OPTIONS = [
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' },
  { label: 'Monitor', value: 'HasErrors' }
];

export const ASSESSMENT_SETUP_ZONES_ROLES = {
  ATTACKER: 'attacker',
  TARGET: 'target'
};

export const MODULE_CONTENT_MAP = {
  scenario: 'Scenario',
  projecttemplate: 'Assessment Template',
  blueprinttemplate: 'Blueprint',
  attackgraphtemplate: 'Attack Graph Template',
  flexpackage: 'Flex Package'
};

export const CONTENT_MODULE_IDS = {
  IN_DEVELOPMENT_MODULE: '0f46d1cb-2305-4464-a154-b4c4eaa63d11'
};

export const API_TO_CONTENTTYPE_MAP = {
  scenarios: 'scenario',
  vendor_products: 'vendor_product',
  vendor_product_domains: 'vendor_product_domain',
  phases: 'phase',
  mitigations: 'mitigation',
  unified_mitigations: 'unified_mitigation',
  stages: 'stage',
  assessment_templates: 'projecttemplate',
  attack_graph_templates: 'attackgraphtemplate'
};

export const SSO_TYPES = {
  SAML: '36d7f42f-73e4-479e-a950-70a42fcf3e28'
};

export const SCENARIO_DETAIL_SLIDE_NAMES = {
  ADVERSARIES_THAT_USE_THIS_SCENARIO: 'adversaries-that-use-this-scenario',
  ASSESSMENTS_THAT_USE_THIS_SCENARIO: 'assessments-that-use-this-scenario',
  SCENARIO_TEMPLATE: 'scenario-template'
};
export const MITRE_TACTICS_UUID = '055cba1f-07fc-4be9-a238-d533f412108d';

export const MITRE_TACTICS_TAG_ID = 'bba8abb4-8af7-478c-9003-6a00487bb387';

export const SIGMA_VENDOR_ID = '7f7c5774-2a04-4743-a17d-db0d1f6a9d8f';

export const HEAP_IO_APP_ID = {
  development: '977568546',
  prod: '1822030442'
};

export const HEAP_VALID_CUSTOMER_TYPES = ['customer'];

export const PHASE_LOG_TRACE_TYPES = {
  MITIGATION: '6',
  REPORT: '5',
  ERROR: '4',
  WARNING: '3',
  INFORMATION: '2',
  DEBUG: '1'
};

export const NETWORK_ASSESSMENT_TEMPLATE_TYPE = 'a2c5d89b-e250-4ce4-afbb-db1d6404a34f';

export const AVA_BOT_TYPES = {
  MITIGATION: 'mitigation',
  SCENARIO: 'scenario',
  SUPPORT: 'support',
  GIT: 'git',
  RESULT: 'result'
};

export const AVA_CHATBOT_VIEWS = {
  REQUEST_EARLY_ACCESS: 1,
  BOT_SELECTION: 2,
  CHAT: 3,
  SUBMIT_FEEDBACK: 4,
  VIEW_SOURCES: 5,
  OPT_IN: 6
};

export const AVA_CHATBOT_RATING = {
  USEFUL: 'good',
  NOT_USEFUL: 'bad'
};

export const UNIFIED_MITIGATION_TYPES = {
  SIGMA: 1,
  YARA: 2,
  SNORT: 3,
  CATEGORY: 4,
  ACTIONABLE: 5,
  TECHNIQUE_MITIGATION_GUIDE: 6,
  DETAILED_HANDS_ON_MITIGATION_GUIDE: 7,
  SPLUNK: 8,
  KQL: 9,
  ELASTIC_EQL_DSL: 10
};

export const HTTP_PATTERN =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;

export const CONNECTOR_MIXINS = {
  ReportDetections: 'Report Detection (Deprecated)',
  ReportEvents: 'Report Events (Deprecated)',
  TechnologyAlertMixin: 'Report Alerts',
  TechnologyAssetMixin: 'Report Assets',
  TechnologyCleanupMixin: 'Suppress Alerts',
  TechnologyEventMixin: 'Report Events',
  TechnologyFieldMixin: 'Report Event Fields',
  TechnologyMappingMixin: 'Report Event Sources',
  TechnologyVersionMixin: 'Report Technology Version',
  TechnologyVulnerabilityMixin: 'Report Vulnerabilities',
  TechnologyAlertEnrichmentMixin: 'Supress Alerts',
  TechnologyAlertAsEventMixin: 'Report Non-Event-Based Alerts',
  TechnologyTestConfigMixin: 'Test Configuration',
  TechnologyQueryConfigurationMixin: 'Event Search Configuration',
  TechnologyStartDelayMixin: 'Delayed Start'
};

export const AVA_SCENARIO_BUILDER_LOCATION = {
  SCENARIO_DEVELOPMENT: 'Scenario Development',
  ASSESSMENT_SETUP: 'Assessment Setup'
};

export const BROADCAST_CHANNEL_NAMES = {
  ENTERPRISE: 'enterprise'
};

export const BROADCAST_CHANNEL_EVENTS = {
  ENTERPRISE: {
    ASSESSMENT_CREATED: 'assessmentCreated'
  }
};
